import { Reducer } from "redux";
import { DataEntryQueueActionTypes } from "../types";
import { IWorkflowItemStep } from "../../../../common/sharedTypes";
import * as actionTypes from "./actionTypes";

// Type-safe initialState!
export interface IDataEntryQueueState {
  workflowItemSteps: IWorkflowItemStep[];
  openWorkflowItemStep: IWorkflowItemStep;
  currentImageWindow: any;
  frontSheet: Uint8Array;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
}

const initialState: IDataEntryQueueState = {
  workflowItemSteps: [],
  openWorkflowItemStep: null,
  currentImageWindow: null,
  frontSheet: null,
  loadingWorkflowSteps: false,
  totalWorkflowItemSteps: 0,
};

const toUint8Array = require("base64-to-uint8array");

const reducer: Reducer<IDataEntryQueueState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case DataEntryQueueActionTypes.LOADING_WORKFLOW_STEPS: {
      return { ...state, loadingWorkflowSteps: action.value };
    }
    case DataEntryQueueActionTypes.TOTAL_WORKFLOW_STEPS: {
      return { ...state, totalWorkflowItemSteps: action.value };
    }
    case DataEntryQueueActionTypes.SEARCH_REPORTS: {
      let _state = { ...state };
      _state = { ...state, workflowItemSteps: action.value };
      return _state;
    }
    case DataEntryQueueActionTypes.OPEN_DATA_ENTRY_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DataEntryQueueActionTypes.ASSIGN_AND_OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DataEntryQueueActionTypes.REMOVE_FROM_QUEUE: {
      let _state = { ...state };
      _state = {
        ...state,
        workflowItemSteps: state.workflowItemSteps.filter((x) => x.id != action.value),
      };
      return _state;
    }
    case DataEntryQueueActionTypes.UNASSIGN: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      return _state;
    }
    case DataEntryQueueActionTypes.COMPLETE_DATA_ENTRY: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }

    case DataEntryQueueActionTypes.LOAD_DATA_ENTRY_IMAGE: {
      let _state = { ...state };
      const fileUrl = action.value.fileUrl;
      const forceNewWindow = action.value.forceNewWindow;
      if (!_state.currentImageWindow || forceNewWindow) {
        _state.currentImageWindow = window.open(fileUrl, "_blank", "width=1000,height=800");
        _state.currentImageWindow.onbeforeunload = function () {
          console.log("unloading window");
          _state.currentImageWindow = null;
        };
      } else {
        console.log(_state.currentImageWindow);
        _state.currentImageWindow.location.href = fileUrl;
      }
      return _state;
    }
    case actionTypes.GET_FRONTSHEET: {
      let _state = { ...state };
      _state = { ...state, frontSheet: toUint8Array(action.value) };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
